import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import axios from 'axios';
// import emailjs from 'emailjs-com';
import Notiflix from 'notiflix';

const DemoProduct = (props) => {

    useDocTitle('Rally - University Marketplace App - Try Our Demo')

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [demoProducts, setDemoProducts ] = useState([])
    const [errors, setErrors] = useState([])


    const handleChange = (e) => {
        const value = e.target.value
        const checked = e.target.checked
        errors.products = []
        if(checked) {
            setDemoProducts([
                ...demoProducts, value
            ])
        } else {
            setDemoProducts(demoProducts.filter( (e) => (e !== value )))
        }
       
    }
    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
    }
    
    function sendEmail(e) {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = 'Loading...';
        let fData = new FormData();
        fData.append('first_name', firstName)
        fData.append('last_name', lastName)
        fData.append('email', email)
        fData.append('phone_number', phone)
        fData.append('message', message)
        fData.append('products', demoProducts)

        // emailjs.sendForm('service_7uy4ojg', 'template_et9wvdg', e.target, 'user_uE0bSPGbhRTmAF3I2fd3s')
        //   .then((result) => {
        //       console.log(result.text);
        //       Notiflix.Report.success(
        //         'Success',
        //         '"Thanks for sending a message, we\'ll be in touch soon."',
        //         'Okay',
        //         );
        //   }, (error) => {
        //       console.log(error.text);
        //       Notiflix.Report.failure(
        //         'An error occured',
        //         'Please try sending the message again.',
        //         'Okay',
        //         );
        //   });

        axios({
            method: "post",
            url: process.env.REACT_APP_DEMO_REQUEST_API,
            data: fData,
            headers: {
                'Content-Type':  'multipart/form-data'
            }
        })
        .then(function (response) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'send message';
            clearInput()
            //handle success
            Notiflix.Report.success(
                'Success',
                response.data.message,
                'Okay',
            );
        })
        .catch(function (error) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'send message';
            //handle error
            const { response } = error;
            if(response.status === 500) {
                Notiflix.Report.failure(
                    'An error occurred',
                    response.data.message,
                    'Okay',
                );
            }
            if(response.data.errors !== null) {
                setErrors(response.data.errors)
            }
            
        });
    }
    return (
        <>
            <div>
                <NavBar />
            </div>
            <div id='demo' className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
                    <form onSubmit={sendEmail} id="demoProductForm">
                        <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <div className="flex">
                                <h1 className="font-bold text-center lg:text-left text-orange-500 uppercase text-4xl">Try Rally Demo</h1>
                            </div>
                            <p className="text-gray-600 my-4 text-lg">Select the features you're interested in trying:</p>
                            <div className="flex items-center my-4">
                                <input 
                                    id="checkbox-1" 
                                    aria-describedby="checkbox-1" 
                                    type="checkbox" 
                                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-orange-300 h-4 w-4 rounded" 
                                    value="marketplace_platform" onChange={handleChange}
                                 />
                                <label htmlFor="checkbox-1" className="ml-3 text-lg font-medium text-gray-900">Campus Marketplace Platform</label>
                            </div>
                            <div className="flex items-center my-4">
                                <input 
                                    id="checkbox-2" 
                                    aria-describedby="checkbox-2" 
                                    type="checkbox" 
                                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-orange-300 h-4 w-4 rounded"
                                    value="real_time_messaging" onChange={handleChange}
                                    />
                                <label htmlFor="checkbox-2" className="ml-3 text-lg font-medium text-gray-900">Real-time Messaging System</label>
                            </div>
                            <div className="flex items-center my-4">
                                <input 
                                    id="checkbox-3" 
                                    aria-describedby="checkbox-3" 
                                    type="checkbox" 
                                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-orange-300 h-4 w-4 rounded" 
                                    value="secure_payments" onChange={handleChange}
                                />
                                <label htmlFor="checkbox-3" className="ml-3 text-lg font-medium text-gray-900">Secure Payment System</label>
                            </div>
                            <div className="flex items-center my-4">
                                <input 
                                    id="checkbox-4" 
                                    aria-describedby="checkbox-4" 
                                    type="checkbox" 
                                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-orange-300 h-4 w-4 rounded"
                                    value="content_moderation" onChange={handleChange}
                                />
                                <label htmlFor="checkbox-4" className="ml-3 text-lg font-medium text-gray-900">Content Moderation</label>
                            </div>
                            <div className="flex items-center my-4">
                                <input 
                                    id="checkbox-5" 
                                    aria-describedby="checkbox-5" 
                                    type="checkbox" 
                                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-orange-300 h-4 w-4 rounded"
                                    value="university_verification" onChange={handleChange}
                                    />
                                <label htmlFor="checkbox-5" className="ml-3 text-lg font-medium text-gray-900">University Verification System</label>
                            </div>
                            <div className="flex items-center my-4">
                                <input 
                                    id="checkbox-6" 
                                    aria-describedby="checkbox-6" 
                                    type="checkbox" 
                                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-orange-300 h-4 w-4 rounded" 
                                    value="bidding_system" onChange={handleChange}
                                />
                                <label htmlFor="checkbox-6" className="ml-3 text-lg font-medium text-gray-900">Bidding System</label>
                            </div>
                            {errors && 
                                <p className="text-red-500 text-sm">{errors.products}</p>
                            }

                        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                <div>
                                    <input 
                                        name="first_name" 
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text" 
                                        placeholder="First Name*" 
                                        value={firstName}
                                        onChange={(e)=> setFirstName(e.target.value)}
                                        onKeyUp={clearErrors}
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.first_name}</p>
                                    }
                                </div>
                                
                                <div>
                                    <input 
                                        name="last_name" 
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text" 
                                        placeholder="Last Name*"
                                        value={lastName}
                                        onChange={(e)=> setLastName(e.target.value)}
                                        onKeyUp={clearErrors}
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.last_name}</p>
                                    }
                                </div>

                                <div>
                                    <input 
                                        name="email"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="email" 
                                        placeholder="Email*"
                                        value={email}
                                        onChange={(e)=> setEmail(e.target.value)}
                                        onKeyUp={clearErrors}   
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.email}</p>
                                    }
                                </div>

                                <div>
                                    <input
                                        name="phone_number" 
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="number" 
                                        placeholder="Phone*"
                                        value={phone}
                                        onChange={(e)=> setPhone(e.target.value)}
                                        onKeyUp={clearErrors}
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.phone_number}</p>
                                    }
                                </div>
                        </div>
                        <div className="my-4">
                            <textarea 
                                name="message" 
                                placeholder="Message*" 
                                className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                value={message}
                                onChange={(e)=> setMessage(e.target.value)}
                                onKeyUp={clearErrors}
                            ></textarea>
                            {errors && 
                                <p className="text-red-500 text-sm">{errors.message}</p>
                            }
                        </div>
                        <div className="my-2 w-1/2 lg:w-2/4">
                            <button type="submit" id="submitBtn" className="uppercase text-sm font-bold tracking-wide bg-orange-500 hover:bg-orange-600 text-white p-3 rounded-lg w-full 
                                    focus:outline-none focus:shadow-outline">
                                Request Demo Access
                            </button>
                        </div>
                    </div>
                    </form>
                    <div className="w-full  lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-orange-500 rounded-2xl">
                        <div className="flex flex-col text-white">     
                            <div className="flex my-4 w-2/3 lg:w-3/4">
                                <div className="flex flex-col">
                                    <i className="fas fa-map-marker-alt pt-2 pr-2" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Campus Support</h2>
                                    <p className="text-gray-100">Available at universities nationwide</p>
                                </div>
                            </div>
                            
                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <div className="flex flex-col">
                                <i className="fas fa-phone-alt pt-2 pr-2" />
                                </div>

                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Contact Us</h2>
                                    <p className="text-gray-100">support@rallyapp.com</p>
                                
                                    <div className='mt-5'>
                                        <h2 className="text-2xl">Download</h2>
                                        <p className="text-gray-100">Available on iOS and Android</p>
                                    </div>
                            
                                </div>
                            </div>
                            
                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <a href="#" target="_blank" rel="noreferrer" className="rounded-full flex justify-center bg-white h-8 text-orange-500 w-8 mx-1 text-center pt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className='fill-current font-black hover:animate-pulse'><path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path></svg>
                                </a>
                                <a href="#" target="_blank" rel="noreferrer" className="rounded-full flex justify-center bg-white h-8 text-orange-500 w-8 mx-1 text-center pt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className='fill-current font-black hover:animate-pulse'><circle cx="4.983" cy="5.009" r="2.188"></circle><path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path></svg>
                                </a>
                                <a href="#" target="_blank" rel="noreferrer" className="rounded-full flex justify-center bg-white h-8 text-orange-500 w-8 mx-1 text-center pt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className='fill-current font-black hover:animate-pulse'><path d="M16.017 13.571c-.508-.286-.853-.767-1.038-1.434a1.31 1.31 0 01-.052-.358h3.141v-.726c0-.799-.251-1.586-.78-2.306-.629-.851-1.591-1.332-2.797-1.332-2.197 0-3.978 1.833-3.978 4.108 0 2.276 1.781 4.109 3.978 4.109 1.742 0 3.163-1.126 3.669-2.772h-1.446c-.444.902-1.27 1.361-2.224 1.361-1.562 0-2.756-1.235-2.756-2.698 0-1.463 1.194-2.699 2.756-2.699.95 0 1.742.453 2.194 1.312h-2.666v1.435h3.478l.033-.068c.065-.128.098-.262.098-.397 0-.179-.035-.331-.098-.419-.065-.089-.164-.134-.294-.134-.229 0-.344.136-.344.407v.064H16.3l.006-.06c.023-.234.113-.392.267-.471a.564.564 0 01.254-.059c.155 0 .281.05.379.151.097.102.146.237.146.404 0 .168-.049.306-.146.413-.098.108-.224.161-.379.161a.537.537 0 01-.4-.168.582.582 0 01-.16-.417h.017v-.065c0-.253-.122-.379-.367-.379-.114 0-.209.042-.284.128-.057.065-.092.168-.108.308l-.038.199-.001-.004z"></path><path d="M8.645 13.063v-1.65h.932v-.724h-2.08v.724h.956v1.65h.192zm3.91.044c.26 0 .483-.091.668-.274.186-.183.278-.404.278-.662 0-.259-.093-.48-.278-.663a.929.929 0 00-.667-.273H10.76c-.26 0-.482.091-.667.273a.901.901 0 00-.278.663c0 .258.092.479.278.662.184.183.407.274.667.274h1.794zm-.006-.732h-1.782a.22.22 0 01-.157-.062.202.202 0 01-.066-.15c0-.058.022-.107.066-.148a.22.22 0 01.157-.062h1.782c.059 0 .11.02.155.062a.202.202 0 01.066.148.2.2 0 01-.066.15.216.216 0 01-.155.062zM7.433 12.938c.26 0 .482-.091.667-.274a.901.901 0 00.278-.662.901.901 0 00-.278-.663.925.925 0 00-.667-.273H5.638c-.259 0-.482.091-.666.273a.902.902 0 00-.279.663c0 .258.093.479.279.662.184.183.407.274.666.274h1.795zm-.006-.732H5.644a.218.218 0 01-.156-.062.2.2 0 01-.066-.15c0-.058.022-.107.066-.148a.218.218 0 01.156-.062h1.783c.059 0 .11.02.156.062a.203.203 0 01.065.148.202.202 0 01-.065.15.216.216 0 01-.156.062zm14.008 1.119a7.516 7.516 0 01-6.948 4.608c-4.161 0-7.535-3.374-7.535-7.535 0-4.161 3.374-7.535 7.535-7.535a7.516 7.516 0 016.949 4.61l1.313-.763A9.241 9.241 0 0014.488 1.5a9.252 9.252 0 00-9.236 9.236 9.252 9.252 0 009.236 9.236 9.241 9.241 0 008.262-5.113l-1.315-.761v-.773z"></path></svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>


    )
}

export default DemoProduct;